import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, EMAIL_HREF, ADDRESS, HOURS, ABN, LEGAL_NAME, LOGO_URL } from './shared';
// 19 — FOOTER · [Trust] [Journey] [SEO/GEO]
// All firm details marked [VERIFY] — do not invent ABN, socials or address.
const columns = [{
  heading: 'Claims',
  links: [{
    label: 'Workers’ compensation',
    href: '/workers-compensation-lawyers-perth/'
  }, {
    label: 'Road accidents',
    href: '/car-accident-lawyers-perth/'
  }, {
    label: 'Public liability',
    href: '/public-liability-lawyers-perth/'
  }, {
    label: 'Catastrophic injury',
    href: '/catastrophic-injury-lawyers-perth/'
  }]
}, {
  heading: 'Firm',
  links: [{
    label: 'How it works',
    href: '#how-it-works'
  }, {
    label: 'Our lawyers',
    href: '/our-lawyers/'
  }, {
    label: 'Fees explained',
    href: '#fees'
  }, {
    label: 'About',
    href: '/about/'
  }]
}, {
  heading: 'Resources',
  links: [{
    label: 'Guides',
    href: '/resources/guides/'
  }, {
    label: 'FAQs',
    href: '/resources/faqs/'
  }, {
    label: 'Client reviews',
    href: '#reviews'
  }, {
    label: 'Contact',
    href: '/contact/'
  }]
}];
export function Footer() {
  return <footer className="w-full bg-ink text-paper" data-id="element-142">
      <div className="mx-auto w-full max-w-6xl px-5 py-14 sm:px-6 lg:px-8" data-id="element-143">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]" data-id="element-144">
          {/* Brand + NAP */}
          <div data-id="element-145">
            <img src={LOGO_URL} alt="Separovic Injury Lawyers" width={200} height={44} className="h-10 w-auto brightness-0 invert" data-id="element-146" />
            <p className="mt-4 max-w-xs text-body text-stone/70" data-id="element-147">
              Established Perth personal injury lawyers providing clear advice
              and strong representation since 1990.
            </p>
            <address className="mt-5 space-y-2.5 not-italic" data-id="element-148">
              <a href={PHONE_TEL} className="flex items-center gap-2.5 text-body text-stone hover:text-ochre" data-id="element-149">
                <PhoneIcon aria-hidden="true" className="h-4 w-4 text-ochre" strokeWidth={1.75} data-id="element-150" />
                {PHONE_DISPLAY}
              </a>
              <a href={EMAIL_HREF} className="flex items-center gap-2.5 text-body text-stone hover:text-ochre" data-id="element-151">
                <MailIcon aria-hidden="true" className="h-4 w-4 text-ochre" strokeWidth={1.75} data-id="element-152" />
                {EMAIL}
              </a>
              <span className="flex items-start gap-2.5 text-body text-stone/70" data-id="element-153">
                <MapPinIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-ochre" strokeWidth={1.75} data-id="element-154" />
                {ADDRESS}
              </span>
            </address>
            <p className="mt-4 text-small text-stone/50" data-id="element-155">
              {HOURS} · ABN {ABN}
            </p>
          </div>

          {columns.map(col => <nav key={col.heading} aria-label={col.heading} data-id="element-156">
              <h2 className="text-small font-semibold uppercase tracking-wider text-stone/60" data-id="element-157">
                {col.heading}
              </h2>
              <ul className="mt-4 space-y-2.5" data-id="element-158">
                {col.links.map(l => <li key={l.label} data-id="element-159">
                    <a href={l.href} className="text-body text-stone/80 hover:text-ochre focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ochre rounded" data-id="element-160">
                      {l.label}
                    </a>
                  </li>)}
              </ul>
            </nav>)}
        </div>

        {/* Legal disclaimer */}
        <div className="mt-12 border-t border-stone/15 pt-8" data-id="element-161">
          <p className="max-w-4xl text-small text-stone/55" data-id="element-162">
            The information on this website is general in nature and is not
            legal advice. It does not take account of your individual
            circumstances. Time limits and eligibility for compensation claims
            vary. You should obtain advice specific to your situation before
            acting.
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" data-id="element-163">
            <p className="text-small text-stone/50" data-id="element-164">
              © {new Date().getFullYear()} {LEGAL_NAME}
            </p>
            <ul className="flex flex-wrap gap-x-5 gap-y-2 text-small" data-id="element-165">
              <li data-id="element-166">
                <a href="/privacy/" className="text-stone/70 hover:text-ochre" data-id="element-167">
                  Privacy policy
                </a>
              </li>
              <li data-id="element-168">
                <a href="/terms/" className="text-stone/70 hover:text-ochre" data-id="element-169">
                  Terms
                </a>
              </li>
              <li data-id="element-170">
                <a href="/complaints/" className="text-stone/70 hover:text-ochre" data-id="element-171">
                  Complaints
                </a>
              </li>
              <li data-id="element-172">
                <a href="/sitemap.xml" className="text-stone/70 hover:text-ochre" data-id="element-173">
                  Sitemap
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>;
}